import styles from '../Product.module.scss';
import cx from 'classnames';
import { ProductCardFitmentInfoWrapperProps } from '../types';

export const ProductCardFitmentInfoWrapper = ({
  className,
  children
}: ProductCardFitmentInfoWrapperProps) => {
  return (
    <div
      className={cx(
        styles['product-comparison__card-fitment'],
        'd-flex',
        className
      )}
    >
      {children}
    </div>
  );
};
